module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("CHAPTER")])]), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Victoria Calumet Buchanan. Everything Evan knew about her, he learned in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Town & Country")]), _vm._v(". And Page Six.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Not Geoffrey Thomas Buchanan. Evan kept a dossier on him that would impress a G-man.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Born in Manhattan forty-five years ago and Dalton “prepared,” Geoffrey had lived an aristocrat’s life, spending holidays and summers at homes in Cap d’Antibes, East Hampton, and Bermuda. After graduating from Princeton, he put his biology degree to work at a major pharmaceutical company before returning to Harvard Business School. After HBS, he started and sold two biotech companies, retired, and spent nearly five years traveling the globe, summering in Lake Como, where he bought a villa next to George Clooney’s. In the evenings they played twenty-one on George’s basketball court. The “quiet” life did not suit him, however, and he returned to work, not because he had to, but because he enjoyed "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("the challenge")]), _vm._v(". Now Buchanan served as Chairman and CEO of PharmaPur, Inc., a pharmaceutical company that went public a few years ago. He was also an avid sportsman, popular philanthropist, and gilded member of New York’s elite.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("A confirmed bachelor until eight years ago, Geoffrey met Victoria Calumet at a Bridgehampton polo match. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The New York Times")]), _vm._v("’s wedding feature gushed, “It was love at first sight.” "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("No shit,")]), _vm._v(" Evan thought when he read it. For his part, Evan was quite sure Victoria was the personification of the tired cliché “God’s gift to man.” Just thirty-four years old, only five years Evan’s senior, Victoria had recently been described in a tabloid as “Cameron Diaz’s twin but with a "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Playboy")]), _vm._v(" centerfold’s rack.” "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Not even close")]), _vm._v(". Geoffrey and Victoria honeymooned for a month at the Oberoi, an exclusive resort in Mauritius. A genuflecting "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("T&C")]), _vm._v(" profile piece featured half a dozen photos. Evan made a mental note to visit the Oberoi before he died.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Victoria was Southern perfect by birth, Atlanta, and Vanderbilt educated in art history. After earning her master’s degree, she moved to Manhattan to work for Larry Gagosian in his most prominent Chelsea art gallery. Her parents collected Koons and were Buckhead royalty, of course, but she was smart and talented and, by all accounts, not at all caught up in the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Social Diary")]), _vm._v(" scene. She certainly didn’t obsess about getting Ashley into the “right” Upper East Side nursery school, but Ashley was accepted anyway, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("sans")]), _vm._v(" kickback.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Even Page Six acknowledged that Geoffrey and Victoria were as happy as they were rich.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The whole fucking thing left Evan enviously apoplectic.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecf59e72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 75
// module chunks = 0